/* global width:true */
/* eslint no-undef: "error" */

import React from "react";
import { object, bool, array, func } from "prop-types";
import { LoadMoreStoriesBase } from "@quintype/components";
import get from "lodash/get";

import Headline from "../atoms/headline";
import CardImageType9 from "../molecules/card-image-type-9";
import CardImageType10 from "../molecules/card-image-type-10";
import ReadMore from "../atoms/read-more";
import DfpAd from "../dfp-ad";
import SideBar from "./section/sidebar";
import "./tags.m.css";

class TagPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      width: null
    };
  }
  isWidthPresent = () => {
    this.setState({ width });
  };

  componentDidMount() {
    this.isWidthPresent();
  }

  render() {
    const { data } = this.props;
    const storyFields =
      "headline,subheadline,summary,sections,tags,author-name,author-id,authors,updated-at,last-published-at,published-at,updated-at,first-published-at,metadata,hero-image-metadata,hero-image-s3-key,story-content-id,slug,id,seo,story-template";

    const tagHeadline = () => (
      <div styleName="tag-header">{data.title && <Headline text={data.title} headerType={12} headerLevel={1} />}</div>
    );

    const storiesDom = stories =>
      stories.map((item, index) => {
        const storyObj = item.story || item;

        return (
          <React.Fragment key={index}>
            <div styleName="set-1-story">
              {index % 3 === 0 ? <CardImageType9 story={storyObj} /> : <CardImageType10 story={storyObj} />}
            </div>
            {index + 1 === 8 && (
              <div styleName="ad">
                <DfpAd adtype="leaderboard_2_728x90" />
              </div>
            )}
            {(index + 1) % 4 === 0 &&
              index + 1 >= 12 && (
                <div styleName="ad">
                  <DfpAd adtype="leaderboard_2_728x90" />
                </div>
              )}
          </React.Fragment>
        );
      });

    const StoriesTemplate = ({ onLoadMore, stories, noMoreStories }) => {
      return (
        <div styleName="bottom-stories">
          {storiesDom(stories)}
          {!noMoreStories && stories.length >= 20 && <ReadMore onClick={onLoadMore} />}
        </div>
      );
    };

    const trendingCollection = get(data, ["trendingCollection", "collection"], {});
    const webSpecialCollection = get(data, ["webSpecialCollection", "collection"], {});
    const opinionsCollection = get(data, ["opinionsCollection", "collection"], {});
    const horoscopeCollection = get(data, ["horoscopeCollection", "collection"], {});
    const viralCollection = get(data, ["viralCollection", "collection"], {});

    return (
      <div styleName="wrapper">
        {this.state.width <= 992 && (
          <div className="dfp-ad">
            <DfpAd adtype="banner_2_300x100" />
          </div>
        )}
        <div>
          {tagHeadline()}
          <div styleName="bottom-stories-with-sidebar">
            <LoadMoreStoriesBase
              template={StoriesTemplate}
              fields={storyFields}
              params={{ "tag-slugs": data.tag.slug }}
              data={data}
              numStoriesToLoad={4}
            />
            <div styleName="sidebar">
              <SideBar
                trendingCollection={trendingCollection}
                webSpecialCollection={webSpecialCollection}
                opinionsCollection={opinionsCollection}
                horoscopeCollection={horoscopeCollection}
                viralCollection={viralCollection}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export { TagPage };

TagPage.propTypes = {
  data: object,
  onLoadMore: func,
  stories: array,
  noMoreStories: bool
};
